<template>
	<div class="fill-height white">
		<AppBar :to-page="'/'" dark :color="config.color" />
		<header class="header-page primary">

			<v-container v-if="canCheckin || closedMode ">
				<section class="secondary--text">
					<v-app-bar-title
						v-if="!closedMode"
						class="flex text-h6 text-center font-weight-black"
						> 
							{{ t("confirmation.header.title") }} 	
					</v-app-bar-title>
					<v-app-bar-title class="flex text-h6 text-center font-weight-black" v-else>
						{{ $t("global.confirm") }} <v-icon style="color: green;">verified</v-icon>
					</v-app-bar-title>
				</section>
				<section style="display: block; color: whitesmoke;" >
					<p
						class="text-center font-weight-medium"
						v-html="t('confirmation.header.subtitle')"
						style="line-height: 1.2rem !important; display: block;margin-bottom: unset;font-size: 15px;"
					>
			
					</p>
				</section>
			</v-container>
			<v-container v-else>
				<section class="secondary--text">
					<v-app-bar-title
						v-if="!closedMode"
						class="flex text-h6 text-center font-weight-black"
						> 
							{{ $t("global.editYourRideTitle") }}	
					</v-app-bar-title>
				</section>
			</v-container>
		</header>

		
		
		<v-card elevation="4" class="mb-4">
			<v-container  style="margin-bottom: 90px;">
				<v-row>
					<v-col cols="12">
						<LayoutBase
							:title="t('pickupDropOff.reservationNumber')"
						>
							<CardReservationNumber
								:service="checkinModel"
								:confirm-mode="false"
							/>
						</LayoutBase>
					</v-col>
					<v-col cols="12">
						<LayoutBase
							dark
							:title="t('pickupDropOff.title')"
							:disabledEdit="!canEdit"
						>
							<LayoutCard
								@click="clicked('none')"
								icon="hail"
								:title="t('pickupDropOff.form.pickup.location')"
								>{{ pickupfullName }}</LayoutCard
							>
							<LayoutCard
								@click="clicked('none')"
								class="mt-3"
								icon="location_on"
								:title="
									t('pickupDropOff.form.dropOff.location')
								"
								>{{ dropofffullName }}</LayoutCard
							>
						</LayoutBase>
					</v-col>
					<v-col cols="12" v-if="existAirport">
						<LayoutBase
							:title="t('flight.title')"
							:disabledEdit="!canEdit"
                            edit="false"
                            :emitClick="true"
                            @editClicked="clicked('flight')"
							
						>
                            <LayoutFlight
                                :flightNumber="`${checkinModel.flightNumber} ${airline}`"
                                :flightTime="checkinModel.flightDatetime"
                                 @click="clicked('flight')"
                            />
						</LayoutBase>
					</v-col>
					<v-col cols="12">
						<LayoutBase
							:title="t('schedule.title')"
						>
							<LayoutDateTime
								@click="clicked('none')"
								:pickupTime="checkinModel.pickupDatetime"
                				:pickupTimeLimit="checkinModel.pickupDatetimeLimit"
								:dateTitle="t('schedule.pickupDate')"
								:timeTitle="t('schedule.pickupTime')"
							/>
						</LayoutBase>
					</v-col>
					<v-col cols="12">
						<LayoutBase
							:title="t('passenger.titleConfirm')"
							:disabledEdit="!(canEditPax)"
							edit="-"
                            :emitClick="true"
                            @editClicked="clicked('pax')"
						>
							<CardTransferType @click="clicked('pax')" confirm-mode />
						</LayoutBase>
					</v-col>
					<v-col cols="12">
						<LayoutBase
							:title="t('confirmation.form.specialRequest')"
						>
							<v-card
								elevation="4"
								width="100%"
								class="rounded-lg"
							>
								<v-textarea
									:class="{ 'locked-textarea': !canEdit }"
									height="100%"
									hide-details=""
									v-model="clientNote"
									dense
									:disabled="!canEdit"
									outlined
									:placeholder="placeHolderNote"
								></v-textarea>
							</v-card>
						</LayoutBase>
						<div
							class="mx-3 mt-1 caption font-weight-thin"
							v-if="!disabledNode"
						>
							{{ t("confirmation.form.specialRequestMessage") }}
						</div>
						<div
							class="mx-3 mt-1 caption font-weight-thin red--text"
							v-else
						>
							{{ $t("info.locked.aftertime") }}
						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-card class="mt-4" elevation="4" v-if="!closedMode" style="position: fixed; bottom: 0; left: 0; width: 100%; background-color: #E5E3FF;"  >
			<v-container>
				<v-row dense class="justify-center" v-if="haveChanged && canEdit"  >
					<v-col cols="8">
                        <v-btn
							color="secondary"
                            style="color: #4F39CF !important;font-weight: bold !important;"
							block
							rounded
							@click="save"
                            :disabled="!haveChanged"
							><v-icon  :class="haveChanged?'__shake':''">save</v-icon>
                            {{ $t("global.btnSave") }}</v-btn
						></v-col
					>
				</v-row>
				<section v-if="canCheckin && !haveChanged">
					<div>
						<v-row align="center" justify="center">
							<v-col cols="auto" class="d-flex align-center">
								<v-checkbox
									v-model="acceptTerms"
									:key="check"
									@click="openTerms"
									hide-details
									class="ma-0 pa-0"
								></v-checkbox>

								<div
								class="black--text font-weight-black ml-2"
								style="cursor: pointer"
								@click="dialog.termAndConditions = true"
								>
								<span>I accept </span>
								<a
									class="text-decoration-underline black--text"
								>
									terms and conditions
								</a>
								</div>
							</v-col>
						</v-row>

						<v-row dense class="justify-center">	
							<v-col cols="6">
								<v-btn
									color="primary"
									:disabled="!acceptTerms"
									block
									rounded
									@click="dialog.confirmation = true"
									>{{ $t("global.btnSaveAndSend") }} 
									<v-icon style="color: green;">check</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</div>
				</section>
			</v-container>
		</v-card>

		<DialogTermAndCond
			v-model="dialog.termAndConditions"
			@accept="acceptTerms = true"
		/>
		<DialogMessages
			v-model="dialog.confirmation"
			type="confirm"
			:title="info.title"
		>
			{{ info.message }}
			<template v-slot:bottom>
				<v-card-actions>
					<v-btn
						rounded
						color="primary"
						small
						class="font-weight-bold"
						@click="send()"
						><div class="px-2">
							{{ $t("global.btnConfirmSend") }}
						</div></v-btn
					>
				</v-card-actions>
			</template>
		</DialogMessages>
		
        <v-dialog v-model="modalVisible" max-width="600px"  content-class="custom-dialog">
			<v-card>
				<v-card-title class="headline">
					
				</v-card-title>
				
				<v-card-text class="p-0">
					<div v-if="sectionEditing ==='none' || alert.content ">	
						<v-alert
							type="info"
							color="blue darken-2"
							border="left"
							elevation="1"
							dense
							prominent
							class="my-2 white--text"
							>
								{{ alert.content }}
							</v-alert>
							<DialogHelpSc></DialogHelpSc>
					</div>
					<EditFlightInfo
						v-if="sectionEditing === 'flight'"
						:flightNumber="checkinModel.flightNumber"
						:airline="airline"
						@close="modalVisible = false"
					/>
                    <EditPaxInfo v-if="sectionEditing === 'pax'"></EditPaxInfo>
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
import AppBar from "@/components/AppBar";
import CardReservationNumber from "@/components/card/CardReservationNumber";
import CardTransferType from "@/components/card/CardTransferType";
import LayoutBase from "@/layouts/LayoutBase";
import LayoutCard from "@/layouts/LayoutCard";
import LayoutDateTime from "@/layouts/LayoutDateTime";
import LayoutFlight from "@/layouts/LayoutFlight";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { mapFields } from "@/helpers/mapFields";
import EditFlightInfo from "@/views/checkin/form/FormFlight/FormFlight";
import EditPaxInfo from "@/views/checkin/reservation/InfoPassenger.vue";
import DialogTermAndCond from "@/components/dialog/DialogTermsAndCond";
import DialogHelpSc from "@/components/ShuttleCentralContact.vue"
import DialogMessages from "@/components/dialog/DialogMessages";
export default {
	components: {
		AppBar,
		LayoutBase,
		LayoutCard,
		LayoutDateTime,
        LayoutFlight,
		CardTransferType,
		CardReservationNumber,
        EditFlightInfo,
        EditPaxInfo,
		DialogTermAndCond,
		DialogHelpSc,
		DialogMessages
	},
	data: () => ({
		config: {
			color: "primary"
		},
		dialog: {
			confirmation: false,
			termAndConditions: false
		},
		acceptTerms: false,
		check: 0,
        sectionEditing:'',
        modalVisible:false,
        originalData:null,
		alert:{
			title:"",
			content:"",
			showScContact:false
		}
	}),
	computed: {
		...mapGetters("service", [
			"isArrival",
			"getBasePath",
			"existAirport",
			"inputDisable",
			"inputDisableType",
			"closedMode"
		]),
		...mapState("service", ["checkinModel","events"]),
		...mapFields({
			fields: ["clientNote"],
			base: "checkinModel",
			mutation: "SET_UPDATE_MODEL",
			module: "service"
		}),

		pickupfullName: vm => vm.checkinModel.pickup?.fullName || "",
		dropofffullName: vm => vm.checkinModel.dropoff?.fullName || "",
		
		disabledNode: vm => vm.inputDisableType === "aftertime",
		placeHolderNote: vm =>
			vm.disabledNode
				? ""
				: vm.t("confirmation.form.specialRequestPlaceholder"),
		flightDateTitle() {
			return this.isArrival
				? "flight.form.arrivalDate"
				: "flight.form.takeoffDate";
		},
		flightTimeTitle() {
			return this.isArrival
				? "flight.form.arrivalTime"
				: "flight.form.takeoffTime";
		},
        airline: service => service.flightValidationData?.airline || "",
        haveChanged:(vm)=>{
            if(! (vm.checkinModel.clientNote)){
                vm.checkinModel.clientNote = null;
            }
            //let original = JSON.parse(vm.originalData);
            //console.log("--->",vm.checkinModel.clientNote,original?.clientNote??"--")
            let currentData = {...vm.checkinModel}
            currentData = JSON.stringify(currentData);
            return (currentData !== vm.originalData)
        },
        canEdit(){
            return (!this.closedMode && this.checkinModel.attribs.editWindow && (!this.checkinModel.locked));
        },
		canEditPax(){//special case (Can edit with certain settings)
			return (!this.closedMode && this.checkinModel.attribs.editWindow);
		},
		canCheckin(){
			return this.checkinModel.attribs.checkinWindow
		},
		info: vm => ({
			title: vm.$t(`global.message.confirm.title`),
			message: vm.$t(`global.message.confirm.message`)
		})
	},
	methods: {
		...mapActions("global", ["_initIntercom"]),
		...mapActions("service", ["_updateService", "_fetchServiceById"]),
		...mapActions("global", ["_triggerEventMkt"]),
        ...mapMutations("service", ["RESET_STATE"]),
		openTerms() {
			if (this.acceptTerms) {
				this.dialog.termAndConditions = true;
				this.acceptTerms = undefined;
				setTimeout(() => this.check++, 100);
			}
		},
		toTravelers() {
			this.$router.push({
				path: "/",
				query: { token: this.$route.query.token }
			});
		},
        routeTo(path){
            if (!this.closedMode) this.$router.push(this.getBasePath(path));
        },
		async save() {
            let objOld  = JSON.parse(this.originalData);
            let objNew  = {...this.checkinModel};
            let changes = this.deepDiff(objOld,objNew);
			this._updateService(changes).then(async () => {
				this._triggerEventMkt("edit_done");
				await this._fetchServiceById();
                this.setOriginalState();
				this.$root.show({
					type: "success",
					title: this.$t("section.traveler.savedSuccessfullyTitle"),
					description: this.$t("section.traveler.savedSuccessfullyDescription")
				});
			});
		},
		t(key, options = {}) {
			return this.$t(`section.${key}`, options);
		},
        clicked(mod){
			
			this.alert.content = null;
			this.alert.showScContact = false;
			this.sectionEditing= "none";
			
			//EXCEPTION 
			if(mod=="pax" && this.canEditPax ){
				this.sectionEditing= mod
				this.modalVisible  = true;
				return;
			}
			if(!this.canEdit){
				this.alert.content = this.$t("section.confirmation.lock.byAccount");
				if(!this.checkinModel.attribs.editWindow){
					this.alert.content = this.$t("section.confirmation.lock.byTime");
					this.alert.showScContact = true;
				}
			}else if(mod==="none"){
				this.alert.content = this.$t("section.confirmation.lock.byAccount");
			}
			this.modalVisible  = true;
			if(this.alert.content){
				console.log(this.checkinModel.locked,this.checkinModel.attribs)
				return;
			}
            //if(!this.canEdit) return
            this.sectionEditing= mod
        },
        setOriginalState(){
            this.originalData = {...this.checkinModel};
            this.originalData = JSON.stringify(this.originalData );
        },
        deepDiff(oldObj, newObj) {
            const changes = {};
            const keys = new Set([...Object.keys(oldObj), ...Object.keys(newObj)]);
            keys.forEach(key => {
                const oldVal = oldObj[key];
                const newVal = newObj[key];

                if (typeof oldVal === 'object' && oldVal !== null && typeof newVal === 'object' && newVal !== null) {
                    const nestedChanges = this.deepDiff(oldVal, newVal);
                    if (Object.keys(nestedChanges).length > 0) {
                        changes[key] = nestedChanges;
                    }
                } else if (oldVal !== newVal) {
                    changes[key] = newVal;
                }
            });

            return changes;
        },
		async send() {
			this.dialog.confirmation = false;
			this._updateService({
				//clientNote: this.clientNote,
				checkinStatus: "acepted"
			}).then(async () => {
				this._triggerEventMkt("checkin_done");
				await this._fetchServiceById();
				this.$root.show({
					type: "success",
					title: this.$t("global.message.success.title"),
					description: this.$t("global.message.success.message")
				});
				if (this.$route.query.utm_source == "travelers") {
          			this.RESET_STATE()
					this.toTravelers();
				}
			});
		}
	},
    watch: {
        events: {
            deep: true,
            handler(newEvent) {
                if (!newEvent?.key) return;
                switch (newEvent.key) {
                    case "saved":
                        this.modalVisible = false;
                        break;
                    case "cancel":
                        this.modalVisible = false;
                        break;
                }
            }
        }
    },
    mounted(){
		//this._initIntercom();
        this.setOriginalState()
    }
};
</script>

<style scoped >
.icon-edit {
	position: fixed;
	right: 5px;
	top: 5px;
    /*width: 0px !important;*/
}
.__shake {
  display: inline-block;
  animation: wiggle 2s ease-in-out infinite;
  /*transform-origin: center;*/

}
@keyframes wiggle {
  0% { transform: rotateZ(0deg); }
  15% { transform: rotateZ(-20deg); }
  30% { transform: rotateZ(15deg); }
  45% { transform: rotateZ(-12deg); }
  60% { transform: rotateZ(8deg); }
  75% { transform: rotateZ(-5deg); }
  100% { transform: rotateZ(0deg); }
}
</style>

<style>
.custom-dialog {
  margin: 5px auto; /* default desktop spacing */
}

@media (max-width: 600px) {
  .custom-dialog {
    margin: 8px !important; /* tighter spacing on mobile */
  }
}
.locked-textarea {
  background-color: #f0f0f0 !important; /* gris claro */
  pointer-events: none; /* para prevenir focus */
  color: #555; /* texto más oscuro si quieres */
}

</style>



